export default {
  state: {
    shareStatus: {
      shared: false,
      shareLink: ''
    }
  },
  mutations: {
    setShareStatus(state, payload) {
      if (payload.shared === false) {
        state.shareStatus.shared = false
      } else {
        state.shareStatus.shared = true
        state.shareStatus.shareLink = payload.shareLink
      }
    }
  }
}
